import { Component, Primary, Secondary, Central, Hanger } from './action-bar';
const ActionBar = Component;
ActionBar.Primary = Primary;
ActionBar.Secondary = Secondary;
ActionBar.Central = Central;
ActionBar.Hanger = Hanger;
export { ActionBar };
